import { render, staticRenderFns } from "./page.vue?vue&type=template&id=6b610ce8&scoped=true"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"
import style0 from "./page.vue?vue&type=style&index=0&id=6b610ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b610ce8",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/page.vue
// module id = null
// module chunks = 